function setVisibility(field, visible) {
  const input = field.querySelector("input");
  const toggle = field.querySelector("[data-password-toggle]");
  if (!input || !toggle) return;

  input.type = visible ? "text" : "password";
  toggle.setAttribute("aria-pressed", String(visible));
  toggle.setAttribute("aria-label", visible ? toggle.dataset.passwordHideLabel : toggle.dataset.passwordShowLabel);
  toggle.querySelector("[data-password-show-icon]").classList.toggle("hidden", visible);
  toggle.querySelector("[data-password-hide-icon]").classList.toggle("hidden", !visible);
}

export function resetPasswordVisibility(root = document) {
  root.querySelectorAll("[data-password-field]").forEach((field) => setVisibility(field, false));
}

function initializePasswordVisibility() {
  document.querySelectorAll("[data-password-field]").forEach((field) => {
    const input = field.querySelector("input");
    const toggle = field.querySelector("[data-password-toggle]");
    if (!input || !toggle) return;

    toggle.setAttribute("aria-controls", input.id);
    toggle.classList.remove("hidden");
  });
}

document.addEventListener("click", (event) => {
  const toggle = event.target.closest("[data-password-toggle]");
  if (!toggle) return;

  const field = toggle.closest("[data-password-field]");
  setVisibility(field, field.querySelector("input").type === "password");
});

document.addEventListener("turbo:load", initializePasswordVisibility);
document.addEventListener("turbo:render", initializePasswordVisibility);
document.addEventListener("turbo:before-cache", () => resetPasswordVisibility());
document.addEventListener("submit", (event) => resetPasswordVisibility(event.target));
